module.exports = __webpack_public_path__ + "4bb75686e772c5f1e26d27904dd52729.pdf";